angular.module('dpw.components')
    .directive('dpwGenerateHtml', [function () {
        return {
            scope: {
                tag: '<',
                className: '@',
                content: '<'
            },
            controllerAs: 'ctrl',
            compile: function () {
                return {
                    pre: function (scope, element) {
                        var tag = scope.tag || 'div';
                        var html = $('<' + tag + '>')
                            .addClass(scope.className)
                            .html(scope.content)[0].outerHTML;

                        element.replaceWith(html);
                    }
                };
            }
        };
    }]);
